import { useQuery } from '@tanstack/react-query';

interface Comparison {
  change: number;
  percentChange: number;
  direction: 'up' | 'down' | 'flat';
}

interface CommunityMetrics {
  peakCustomersOut: number;
  peakTimestamp: string | null;
  totalOutageHours: number;
  outageFrequency: number;
}

interface CommunityComparisons {
  peakCustomersOut: Comparison | null;
  totalOutageHours: Comparison | null;
  outageFrequency: Comparison | null;
}

interface Community {
  name: string;
  county: string;
  metrics: CommunityMetrics;
  comparisons: CommunityComparisons;
}

export interface CommunityInsightsData {
  communities: Community[];
  period: {
    start: string;
    end: string;
    label: string;
  };
}

export function useCommunityInsights(startDate: string, endDate: string) {
  return useQuery({
    queryKey: ['communityInsights', startDate, endDate],
    queryFn: async (): Promise<CommunityInsightsData> => {
      const params = new URLSearchParams({ start: startDate, end: endDate });
      const res = await fetch(`/api/insights/communities?${params}`);
      if (!res.ok) throw new Error('Failed to fetch community insights');
      return res.json();
    },
    staleTime: 60000,
    refetchInterval: 300000,
  });
}
